import { Button, Drawer, Form, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import TextArea from "antd/es/input/TextArea";

const AddReport = ({ open, close, getReportFiledList }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleCreateCategory = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/new-filed-report", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Filed new report successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getReportFiledList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="File a report"
      width={window.innerWidth > 710 ? 500 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleCreateCategory}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="description"
            label="Description Report"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea
              //  placeholder="Description report"
              rows={4}
              size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddReport;
